import { createFileRoute } from '@tanstack/react-router'
import { DashboardRouter } from '@/features/dashboard/dashboard-router'

export const Route = createFileRoute('/_authenticated/_organization/')({
  component: DashboardRouter,
})
